var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/action/event_24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.6,14.2 L14,14.2 C13.34,14.2 12.8,14.74 12.8,15.4 L12.8,19 C12.8,19.66 13.34,20.2 14,20.2 L17.6,20.2 C18.26,20.2 18.8,19.66 18.8,19 L18.8,15.4 C18.8,14.74 18.26,14.2 17.6,14.2 Z M17.6,2.2 L17.6,3.4 L8,3.4 L8,2.2 C8,1.54 7.46,1 6.8,1 C6.14,1 5.6,1.54 5.6,2.2 L5.6,3.4 L4.4,3.4 C3.068,3.4 2.012,4.48 2.012,5.8 L2,22.6 C2,23.92 3.068,25 4.4,25 L21.2,25 C22.52,25 23.6,23.92 23.6,22.6 L23.6,5.8 C23.6,4.48 22.52,3.4 21.2,3.4 L20,3.4 L20,2.2 C20,1.54 19.46,1 18.8,1 C18.14,1 17.6,1.54 17.6,2.2 Z M20,22.6 L5.6,22.6 C4.94,22.6 4.4,22.06 4.4,21.4 L4.4,9.4 L21.2,9.4 L21.2,21.4 C21.2,22.06 20.66,22.6 20,22.6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/event",
    transform: "translate(-2.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/action/event_24px",
    fill: "currentColor",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.b3ae8248a27f61afe1416d59d21506e1.svg";
export { ForwardRef as ReactComponent };